import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3d2a4016"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header",
  id: "grid-item-head"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ONavbar = _resolveComponent("ONavbar");
  const _component_OInputForm = _resolveComponent("OInputForm");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid-content container-fluid", $options.compTheme]),
    id: "grid-item-content"
  }, [_createElementVNode("header", _hoisted_1, [_createVNode(_component_ONavbar, {
    theme: $props.theme
  }, null, 8, ["theme"])]), _createElementVNode("main", {
    class: _normalizeClass(["main", $options.compTheme]),
    id: "grid-item-main"
  }, [_createVNode(_component_OInputForm, {
    theme: $props.theme
  }, null, 8, ["theme"])], 2)], 2);
}